'use client';

import { c as _c } from "react/compiler-runtime";
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { Switch } from '@repo/ui';
import { useAnalyticsConsentContext } from '@/components/providers/AnalyticsConsentProvider';

/**
 * "Share analytics" row for the nav menu. Rendered as a menu checkbox item so
 * Radix's roving focus reaches it (a bare Switch is unreachable inside
 * `DropdownMenu.Content`); the Switch is a visual indicator only. Toggling off
 * opts PostHog out and sets the `mo-analytics-opted-out` cookie; toggling on
 * reverses both.
 */
const AnalyticsSwitch = () => {
  const $ = _c(7);
  const {
    isAnalyticsEnabled,
    setAnalyticsEnabled
  } = useAnalyticsConsentContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span className="text-muted-foreground text-xs">Share analytics</span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== isAnalyticsEnabled) {
    t1 = <Switch checked={isAnalyticsEnabled} tabIndex={-1} aria-hidden={true} className="pointer-events-none" />;
    $[1] = isAnalyticsEnabled;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isAnalyticsEnabled || $[4] !== setAnalyticsEnabled || $[5] !== t1) {
    t2 = <DropdownMenu.CheckboxItem checked={isAnalyticsEnabled} onCheckedChange={setAnalyticsEnabled} onSelect={_temp} className="hover:bg-muted data-highlighted:bg-muted flex h-[25px] w-full min-w-[176px] cursor-pointer items-center justify-between rounded-lg px-[6px] outline-none">{t0}{t1}</DropdownMenu.CheckboxItem>;
    $[3] = isAnalyticsEnabled;
    $[4] = setAnalyticsEnabled;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default AnalyticsSwitch;
function _temp(event) {
  return event.preventDefault();
}